import { useRouteError } from 'react-router-dom'
import { isModuleLoadError } from '@/lib/module-load'
import { LoadFailure } from './ModuleRecovery'

export function RouteErrorPage() {
  const error = useRouteError()
  return (
    <main>
      <LoadFailure module={isModuleLoadError(error)} />
    </main>
  )
}
